var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCameraAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H16C17.1046 3 18 3.89543 18 5V5.93333L20.4086 4.167C21.0692 3.68261 22 4.1543 22 4.97341V11.0266C22 11.8457 21.0692 12.3174 20.4086 11.833L18 10.0667V11C18 12.1046 17.1046 13 16 13H11.3385L15.6708 21.6646C15.8561 22.0351 15.7059 22.4856 15.3354 22.6708C14.9649 22.8561 14.5144 22.7059 14.3292 22.3354L10 13.6771L5.67082 22.3354C5.48558 22.7059 5.03507 22.8561 4.66459 22.6708C4.29411 22.4856 4.14394 22.0351 4.32918 21.6646L8.66147 13H4C2.89543 13 2 12.1046 2 11V5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraAlt1);
export default __webpack_public_path__ + "static/media/video-camera-alt-1.50130ada9028f10be73deccc06cce5a5.svg";
export { ForwardRef as ReactComponent };